import React from "react";
import "./PastMembers.css";

/* ================= ARC ================= */
export function ARCMembers() {
  return (
    <section className="arc-section">
      <h2>ACADEMIC RESOURCE COUNCIL (ARC)</h2>

      <div className="members-list">
        <div className="member-item">
          <h3>1. G Suvarna Lakshmi</h3>
          <p>Professor & Head, Department of ELT, School of Distance Education, EFLU</p>
          <p>Formerly Professor & Head, Dept. of English & Humanities, JNTUK</p>
          <p><strong>Email:</strong> Suvarna1974@yahoo.com</p>
        </div>

        <div className="member-item">
          <h3>2. K Venkat Reddy</h3>
          <p>Professor Department of Training & Development</p>
          <p>English and Foreign Languages University</p>
          <p><strong>Email:</strong> venkatciefl@gmail.com</p>
        </div>

        <div className="member-item">
          <h3>3. Mrunalini Talla</h3>
          <p>Professor of Education</p>
          <p>Dept. of Education, Osmania University</p>
          <p><strong>Email:</strong> mrunalinitalla@yahoo.com</p>
        </div>

        <div className="member-item">
          <h3>4. V Jagadeeswar Rao</h3>
          <p>Professor</p>
          <p>Education Multimedia Research Centre, Osmania University</p>
          <p><strong>Email:</strong> vjemrc@gmail.com</p>
        </div>

        <div className="member-item">
          <h3>5. V Viswanadham</h3>
          <p>Professor (Retd), Head Dept. of Commerce</p>
          <p>Osmania University</p>
          <p>Currently engaged in multiple social activities</p>
          <p><strong>Email:</strong> Viswam.vangapally@gmail.com</p>
        </div>

        <div className="member-item">
          <h3>6. K Rani Rajitha Madhuri</h3>
          <p>Head, Dept. of English & Foreign Languages</p>
          <p>Dr BR Ambedkar Open University</p>
          <p><strong>Email:</strong> raniraj_k@yahoo.com</p>
        </div>

        <div className="member-item">
          <h3>7. Geetha Gopinath</h3>
          <p>Asst. Professor, Dept. of Education & Educational Technology</p>
          <p>School of Social Sciences, Central University of Hyderabad</p>
          <p><strong>Email:</strong> drgeethagopinath@gmail.com</p>
        </div>

        <div className="member-item">
          <h3>8. Akanksha Shukla</h3>
          <p>Associate Professor & Head, Centre for Development, Documentation & Communication</p>
          <p>National Institute of Rural Development & Panchayat Raj</p>
          <p><strong>Email:</strong> aks47aks@gmail.com</p>
        </div>

        <div className="member-item">
          <h3>9. P M Lakshmi</h3>
          <p>Development Professional</p>
          <p>CSO Sector (16 yrs), Nominated as National Resource Person</p>
          <p>Active on 'SAMPOORNA' - Global Center for Development of Whole Child (GCDWC)</p>
          <p>Intervention 'Whole Child Development Framework' for Children with low resources in Telangana Social & Tribal Welfare Residential Schools</p>
          <p><strong>Email:</strong> lakshmipm.devpprof@gmail.com</p>
        </div>

        <div className="member-item">
          <h3>10. Dr. Ravi Chandra Raju Gangapatnam (PhD, Psychology)</h3>
          <p>Development Professional</p>
          <p>CSO Sector (20 yrs), Nominated as National Resource Person</p>
          <p>Engaged with multiple sectors including Govt Organizations</p>
          <p><strong>Email:</strong> bhavishyaplus@gmail.com</p>
        </div>

        <div className="member-item">
          <h3>11. Dr Rao VBJ Chelkani (PhD) - Project Advisor</h3>
          <p>Former Associate, UNESCO HO, Paris</p>
          <p><strong>Email:</strong> raovbj@yahoo.com</p>
        </div>
      </div>
    </section>
  );
}

/* ================= FIT ================= */
export function FITMembers() {
  return (
    <section className="fit-section">
      <h2>FIELD IMPLEMENTATION TEAM (FIT)</h2>
      <p className="fit-subtitle">Project - II & III</p>

      <div className="members-list">
        <div className="member-item">
          <h3>1. Alluri Neha</h3>
          <p>Formerly DGM-CSR-NBL</p>
          <p>Co-Founder Manduva Project</p>
        </div>

        <div className="member-item">
          <h3>2. Vanga Joseph Peter</h3>
          <p>Sr. Media Professional - Educational Programs</p>
          <p>Civil Society Member</p>
        </div>

        <div className="member-item">
          <h3>3. K Krishna Prasad</h3>
          <p>'Feed Mind and Body' - Convener</p>
          <p>Civil Society Member</p>
        </div>

        <div className="member-item">
          <h3>4. R Lakshmi Durga</h3>
          <p>AP SMART Villages Contributor</p>
          <p>Former Corporate Personnel</p>
          <p>Civil Society Member</p>
        </div>

        <div className="member-item">
          <h3>5. K Sudheshna</h3>
          <p>AP SMART Villages Contributor</p>
          <p>Former Corporate Personnel</p>
          <p>Civil Society Member & Founder - Helping Hands</p>
        </div>

        <div className="member-item">
          <h3>6. N Pandu</h3>
          <p>AP SMART Villages Contributor</p>
          <p>Former Corporate Personnel</p>
          <p>Civil Society Member & Founder</p>
        </div>

        <div className="member-item">
          <h3>7. Sandeep Samala</h3>
          <p>Former National Head Marketing CIPET</p>
          <p>Civil Society Member</p>
          <p>Public Relations Manager KL University</p>
        </div>

        <div className="member-item">
          <h3>8. M Urukund</h3>
          <p>Former Skill Development Trainer</p>
          <p>Civil Society Member & Founder Janamoksha Society</p>
        </div>

        <div className="member-item">
          <h3>9. Srinivas Chary</h3>
          <p>Lead India Trainer & Coach</p>
          <p>Civil Society Member</p>
        </div>

        <div className="member-item">
          <h3>10. Nagi Reddy</h3>
          <p>Life Skills Coach and Trainer</p>
          <p>TV Contributor</p>
        </div>

        <div className="member-item">
          <h3>11. Lion V Rajeshwari</h3>
          <p>Life Skills Coach and Trainer</p>
        </div>

        <div className="member-item">
          <h3>12. RB Srinivas</h3>
          <p>Technical Training Expert</p>
        </div>

        <div className="member-item">
          <h3>13. RV Hanumantha Rao</h3>
          <p>Independent Scholar & Corporate Personnel</p>
          <p>Social Sector Volunteer</p>
        </div>

        <div className="member-item">
          <h3>14. V Radha Krishna</h3>
          <p>Independent Scholar & Corporate Personnel</p>
          <p>Social Sector Volunteer</p>
        </div>

        <div className="member-item">
          <h3>15. Usha Bhargav</h3>
          <p>Independent Counsellor </p>
          <p>Sri Satya Sai Organization</p>
        </div>
        <div className="member-item">
          <h3>16. N Sairam</h3>
          <p>Video-shooting & Editing</p>
          <p>Technical Resource</p>
        </div>
      </div>
    </section>
  );
}

/* ============ OPTIONAL PARENT EXPORT ============ */
export default function PastMembers() {
  return (
    <>
      <ARCMembers />
      <FITMembers />
    </>
  );
}
